// React
import React from 'react';
import { Controller } from 'react-hook-form';
// material-ui components
import Divider from '@mui/material/Divider';
import TextField from '@mui/material/TextField';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import FormHelperText from '@mui/material/FormHelperText';
// custom components
import NumberedHeading from '../../../../../shared-components/forms/NumberedHeading';
import EmentorArray from '../shared/EmentorArray';
import SummaryFeedbackArray from './components/SummaryFeedbackArray';
import ImageAttribution from '../shared/ImageAttribution';

const ModuleSummary = (props) => {
  const { control, formState } = props.methods;
  const { errors } = formState;
  const { inputDir } = props;

  return (
    <div>
      <NumberedHeading number="1" title="Label" instructions='Select either "TLO", "ELO 1", or "ELO 2".' required />
      <Controller
        control={control}
        name="content.core.label"
        render={({ field }) => (
          <FormControl fullWidth className='mt-16' size="small" error={!!errors.content?.core?.label} required>
            <InputLabel id="select-tag">Label</InputLabel>
            <Select
              {...field}
              labelId="select-tag"
              id="tag"
              label="Label"
              classes={{ select: "flex items-center space-x-12" }}
              defaultValue=""
            >
              <MenuItem value="" className="space-x-12" disabled>
                Select a Tag
              </MenuItem>
              <MenuItem value="TLO" className="space-x-12">
                TLO
              </MenuItem>
            </Select>
            {!!errors.content?.core?.label ? (
              <FormHelperText>{errors.content?.core?.label?.message}</FormHelperText>
            ) : null}
          </FormControl>
        )}
      />

      <Divider className="my-16" />
      
      <NumberedHeading number="2" title="Image" instructions="Provide the objective image information." />
      <Controller 
        control={control}
        name="content.core.media"
        render={({ field }) => <ImageAttribution targetObj="content.core.media" inputDir={inputDir} errors={errors.content?.core?.media} {...{control }} />}
      />

      <Divider className="my-16" />
      
      <NumberedHeading number="3" title="Module Objective Text (TL)" instructions="Restate the objective for this Module in the Target Language." />
      <Controller
        control={control}
        name="content.core.text_tl"
        render={({field}) => (
          <TextField
            className="mt-16"
            {...field}
            label="Text (TL)"
            placeholder="Text (TL)"
            id="text"
            error={!!errors.content?.text_tl}
            helperText={errors.content?.text_tl?.message}
            variant="outlined"  
            fullWidth
            multiline
            minRows={5}
            maxRows={10}
            required
            dir={inputDir}
          />
        )}
      />
      
      <NumberedHeading number="4" title="Module Objective Text (EN)" instructions="Restate the objective for this Module in English." />
      <Controller
        control={control}
        name="content.core.text_en"
        render={({field}) => (
          <TextField
            className="mt-16"
            {...field}
            label="Text (EN)"
            placeholder="Text (EN)"
            id="text"
            error={!!errors.content?.text_en}
            helperText={errors.content?.text_en?.message}
            variant="outlined"  
            fullWidth
            multiline
            minRows={5}
            maxRows={10}
            required
          />
        )}
      />

      <Divider className="my-16" />

      <NumberedHeading number="4" title="Section Feedback" instructions="Using the controls below, add as many items as needed to provide feedback for the learning objectives and practical exercises." />      
      <Controller
        control={control}
        name="content.item_feedback"
        render={({ field }) => <SummaryFeedbackArray inputDir={inputDir} {...{ control, errors }} />}
      />
    </div>
  )
}

export default ModuleSummary;